/**
 * A clinic's shareable entry URL with a copy control (ZOY-614). Shown only
 * where the slug is already known from `/me/authz`; a clinic without a slug
 * shows nothing at all.
 */

import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, Machine } from '@/ui/kit';
import { entryUrlFor } from '@/core/clinic/entryApi';

export function EntryUrl({ slug }: { slug: string | null | undefined }) {
  const intl = useIntl();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const id = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(id);
  }, [copied]);
  if (!slug) return null;
  const url = entryUrlFor(slug);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        fontSize: 12.5,
        color: 'var(--zc-muted)',
      }}
    >
      <Machine>{url}</Machine>
      <Button
        variant="link"
        onClick={() => {
          void navigator.clipboard
            ?.writeText(url)
            .then(() => setCopied(true))
            .catch(() => setCopied(false));
        }}
      >
        {intl.formatMessage({ id: copied ? 'entry.copied' : 'entry.copy' })}
      </Button>
    </span>
  );
}
